import { useMutation } from "@tanstack/react-query"
import { apiClient } from "~/lib/client"
import { ConditionUpdateVariables, ConditionVariables } from "../../schemas"
import { handleError } from "~/utils/response"
import { handleResponse } from "~/utils/response"
import { CreateConditionResponse, CreateConditionResponseData, UpdateConditionResponse, UpdateConditionResponseData } from "../types"


export const useCreateConditionMutation = () => {
  return useMutation<CreateConditionResponse, unknown, ConditionVariables>({
    mutationFn: async (variables: ConditionVariables) => {
      try {
        const response = await apiClient("/medicals/conditions", {
          method: "POST",
          body: JSON.stringify(variables),
        });

        return await handleResponse<CreateConditionResponseData>(response);
      } catch (error) {
        return handleError(error);
      }
    },
  
  });
};

export const useUpdateConditionMutation = () => {
  return useMutation<UpdateConditionResponse, unknown, ConditionUpdateVariables>({
    mutationFn: async (variables: ConditionUpdateVariables) => {
      try {
        const response = await apiClient(`/medicals/conditions/${variables.id}`, {
          method: "PUT",
          body: JSON.stringify(variables),
        });

        return await handleResponse<UpdateConditionResponseData>(response);
      } catch (error) {
        return handleError(error);
      }
    },
    
  });
};

